<div class="p-24">
  <h3 class="mat-h3">Reference stream mode</h3>
  <p class="mat-body-1">
    Choose how references are streamed: accurate (higher quality) or fast (lower latency).
  </p>

  <mat-form-field class="w-full" appearance="outline">
    <mat-label>Mode</mat-label>
    <mat-select
      id="reference-stream-mode-select"
      [(ngModel)]="value"
      aria-label="Reference stream mode"
    >
      <mat-option value="accurate">Accurate</mat-option>
      <mat-option value="fast">Fast</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="d-flex justify-content-end m-t-16">
    <button mat-raised-button color="accent" (click)="save()">Save</button>
  </div>
</div>
